import { render, staticRenderFns } from "./post-gaduate.vue?vue&type=template&id=0202cf2a&scoped=true"
import script from "./post-gaduate.vue?vue&type=script&lang=js"
export * from "./post-gaduate.vue?vue&type=script&lang=js"
import style0 from "./post-gaduate.vue?vue&type=style&index=0&id=0202cf2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0202cf2a",
  null
  
)

export default component.exports